<template>
    <div class="games">
        <!-- Add game by type -->
        <div class="choice">
            <div class="" v-for="gameType in gameTypeList" :key="gameType.id">
                <router-link :to="{ name: 'game-edit', params: { gameTypeSlug: gameType.slug } }">
                    <div
                        class="game-card twn-card"
                        :title="gameType.description"
                    >
                        <img
                            v-if="gamePictoBySlug[gameType.slug]"
                            class="flex picto-image"
                            :src="gamePictoBySlug[gameType.slug]"
                        />
                        <p class="uppercase text-sm w-full text-center font-principal-bold">
                            {{ gameType.name }}
                        </p>
                    </div>
                </router-link>
            </div>
        </div>

        <!-- Game list -->
        <List
            listing="activity"
            :fields="fields"
            :filters="filters"
            searchText="Rechercher un minijeu"
            editRouteName="game-edit"
            :customRouteParams="customRouteParams"
            :deleteItemOverride="deleteGameByID"
            orderBy="identifier: asc"
            :is-course-resource="true"
        />
    </div>
</template>

<script>
import List from '@/components/List'
import { mapState, mapActions } from 'vuex';

export default {
    name:'MiniGamesList',
    components: { List },
    created() {
        this.getTypeList();
    },
    data() {
        return {
            fields: [
                {
                    key:'identifier',
                    label: 'Identifiant',
                    sortable: true
                },
                {
                    key:'title',
                    label: 'Titre',
                    sortable: true
                },
                {
                    key: 'type',
                    db: `type {
                        name,
                        slug
                    }`,
                    nested: 'name',
                    label: 'Type',
                    sortable: true,
                },
                {
                    label: 'Utilisations',
                    sortable: true,
                    key: 'usedInNodes_aggregate',
                    nested: 'count',
                    db: `
                    usedInNodes_aggregate {
                        aggregate {
                            count
                        }
                    }
                    `
                },
            ],
            filters: [
                {
                    key:'type',
                    label: 'Type'
                }
            ],
            gamePictoBySlug: {
                true_false: require('../assets/images/TRUE_FALSE_ICON.svg'),
                dragdrop: require('../assets/images/DRAG_DROP_ICON.svg'),
                dragdrop_picture: require('../assets/images/VOCABULARY_ICON.svg'),
                drag_drop: require('../assets/images/DRAG_DROP_ICON.svg'),
                quiz: require('../assets/images/QUIZ_SIMPLE_ICON.svg'),
                quiz_simple: require('../assets/images/QUIZ_SIMPLE_ICON.svg'),
                quiz_picture: require('../assets/images/QUIZ_SIMPLE_ICON.svg'),
                quiz_table: require('../assets/images/QUIZ_TABLE_ICON.svg'),
                cell_by_cell: require('../assets/images/CELL_BY_CELL_ICON.svg'),
                reorder: require('../assets/images/REORDER_ICON.svg'),
                vocabulary: require('../assets/images/VOCABULARY_ICON.svg'),
                gap_fill: require('../assets/images/GAP_FILL_ICON.svg'),
                hotspots: require('../assets/images/HOTSPOTS_ICON.svg'),
                message_gallery: require('../assets/images/DRAG_AND_DROP.svg'), //TODO
                message_phone: require('../assets/images/DRAG_AND_DROP.svg'), //TODO
                conversation: require('../assets/images/DRAG_AND_DROP.svg'), //TODO
                survey: require('../assets/images/SURVEY_ICON.svg'),
                quiz_multiple: require('../assets/images/QUIZ_MULTIPLE_ICON.svg'),
            },
        }
    },
    computed: {
        ...mapState({
            gameTypeList: state => state.Games.type_list
        })
    },
    methods: {
        ...mapActions('Games', ['getTypeList', 'deleteGameByID']),
        customRouteParams(item) {
            return {
                gameTypeSlug: item.nested_type.slug,
            }
        },
    }
}
</script>

<style lang="scss">
.choice{
    // box-shadow: inset 0 0 10px 0 rgba(0, 0, 0, 0.1);
    @apply flex-wrap justify-center w-full flex flex-row mb-5;
    @screen lg {
        @apply justify-start;
    }
    .game-card{
        @apply flex flex-col w-44 h-44 cursor-pointer m-4 p-4;
        @screen lg { 
            @apply m-0 mr-4 mb-4;
        }
        
        .picto-image{
            @apply text-principal-selected fill-current p-8;
            height: 100%;
        }

        &:hover{
            box-shadow: 0 0 10px 5px rgba(0, 0, 0, 0.15);
        }
    }
}
</style>